import Browser from "../../browser";
import type Scene from "../../models/Scene";
import { isUiModeExpert } from "../../uiMode";
import { itx } from "../../translationItx/itx";
import ObjectReference from "../ObjectReference";
import type KnxContext from "./KnxContext";

export default function SceneNumberElement(props: {
  id: string;
  instanceId: string;
  moduleId: string;
  inputElement: any;
  style?: any;
  value: number;
  knxContext: KnxContext;
}): any {
  const { id, instanceId, inputElement, style, value, knxContext } = props;

  const sceneNumberOffset = knxContext.device.template?.knxProductData.sceneNumberOffset;

  const extData = knxContext.getExtendedData(id, instanceId);
  if (extData) {
    const isSceneNumberProperty = extData.isSceneNumberProperty;

    if (isSceneNumberProperty) {
      const scene: Scene = extData.scene;
      let sceneName = "";
      if (scene) {
        sceneName = `${scene.sceneNumber} - ${scene.name}`;
      } else {
        sceneName = `${value}  -- ` + itx("KnxParameterViewer.notSceneSelected", "Keine Szene ausgewählt");
      }

      const numberOfSceneMismatch = scene && Number(scene.sceneNumber) + Number(sceneNumberOffset || 0) != value;

      return (
        <div className="estadaRow left" style={style} key={`${sceneName}-${numberOfSceneMismatch}`}>
          <ObjectReference
            obj={scene}
            showName={true}
            showIcon={true}
            useAllwaysMaxSpace={true}
            style={{
              backgroundColor: numberOfSceneMismatch ? "red" : undefined,
            }}
          />
          &nbsp; &nbsp;
          {isUiModeExpert() && inputElement}
        </div>
      );
    }
  }

  if (Browser.isMobile() && !knxContext.isLandscape && style) {
    return (
      <div className="knxValue" style={style}>
        {inputElement}
      </div>
    );
  }

  return inputElement;
}
